import axios from '@/api';
import authHeader from './auth-header';
import * as FilesApi from "@/api/files.api";

const delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};

const FileDownService = {
    async postFileDownChk(fileName) {
        return axios.post(process.env.VUE_APP_API_URL + 'file/fileDownChk', {
            fileName
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(response => {
                return response;
            }).catch(error => {
                console.log(error);
            })
    },

    async getFileDown(file) {
        const downloadUrl = `${process.env.VUE_APP_API_URL}file/fileDown?name=${encodeURIComponent(file)}`;

        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = file;
        document.body.appendChild(a);
        a.click();
        a.remove();
    },

    async postFileDownload(file, options = {}) {
        return new Promise((resolve, reject) => {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = process.env.VUE_APP_API_URL + 'file/fileDown';
            form.target = options.target || '_blank';
            form.style.display = 'none';

            // 파일 이름 또는 기타 필드
            const fileInput = document.createElement("input");
            fileInput.name = "name";
            fileInput.value = file;
            form.appendChild(fileInput);

            // 인증 토큰을 input으로 전달 (예: JWT)
            const headers = authHeader();
            if (headers['x-access-token']) {
                const tokenInput = document.createElement("input");
                tokenInput.name = "x-access-token";  // 서버에서 이 필드를 읽어야 함
                tokenInput.value = headers['x-access-token'];
                form.appendChild(tokenInput);
            }

            document.body.appendChild(form);

            try {
                form.submit();
                resolve();
            } catch (error) {
                reject(error);
            } finally {
                setTimeout(() => {
                    document.body.removeChild(form);
                }, 1000);
            }
        });
    },
    async fileDown(file) {
        const res = await this.postFileDownChk(
            file.name
        );

        if (!res || res.status !== 200) {
            return res;
        }

        const url = res.data.url;

        const finalUrl = new URL(
            url,
            process.env.VUE_APP_API_URL
        ).href;

        window.open(finalUrl, "_blank");

        return res;
    },

    /**
     * 실패한 다운로드 재시도
     */
    async failedDown(file) {
        return await this.getFileDown(
            file.name
        );
    },

    
};

export default FileDownService;